import Vue from 'vue';
import VeeValidate, {Validator} from 'vee-validate';
import zh from 'vee-validate/dist/locale/zh_CN'; // introducing Chinese files

// configuration Chinese
Validator.addLocale(zh);

const config = {
  locale: 'zh_CN'
};

Vue.use(VeeValidate,config);

// custom validate
const dictionary = {
   zh_CN: {
      messages: {
        email: () => '请输入正确的邮箱格式',
        required: ( field )=> "请输入" + field
      },
      attributes:{
        phone: '手机号',
        captcha: '验证码',
        password:'密码',
        username: '姓名',
        IDcard: '身份证号',
        email:'邮箱',
        address: '地址',
        province: '省份',
        city: '城市',
      }
  }
};

Validator.updateDictionary(dictionary);

Validator.extend('phone', {
  messages: {
    zh_CN:field => '请输入正确的' + field,
  },
  validate: value => {
    return value.length == 11 && /^([1][3-9][0-9]{9})$/.test(value);
  }
});

Validator.extend('password', {
  messages: {
    zh_CN:field => field + '必须在6-20位之间',
  },
  validate: value => {
    return value.length >= 6 && value.length <= 20;
  }
});

Validator.extend('captcha', {
  messages: {
    zh_CN:field => '请输入正确的' + field,
  },
  validate: value => {
    return value.length == 4;
  }
});

Validator.extend('IDcard', {
  messages: {
    zh_CN:field => field + '必须是18位',
  },
  validate: value => {
    return value.length == 18;
  }
});

export default Validator;
